/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Content_DescriptionInputs */

const en_legal_content_description = /** @type {(inputs: Legal_Content_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What may not be posted, how to report it, and how we moderate.`)
};

const pl_legal_content_description = /** @type {(inputs: Legal_Content_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czego nie wolno publikować, jak to zgłaszać i jak moderujemy treści.`)
};

/**
* | output |
* | --- |
* | "What may not be posted, how to report it, and how we moderate." |
*
* @param {Legal_Content_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const legal_content_description = /** @type {((inputs?: Legal_Content_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Content_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_legal_content_description(inputs)
	return en_legal_content_description(inputs)
});